<script setup lang="ts">
  import { useGetAccount } from "@/api/account/account"
  import { useGetAccountId } from "@/lib/useGetAccountId"
  import { openWebchat } from "@/services/WebchatService"
  import { computed } from "vue"
  import { Button } from "@/components/ui/button"
  import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from "@/components/ui/dialog"
  import { Icon } from "@/components/ui/icons"
  import { Link } from "@/components/ui/link"

  const HELP_EMAIL = "help@so.energy"

  const { accountId } = useGetAccountId()
  const accountQuery = useGetAccount(accountId)
  const addressLine1 = computed(
    () => accountQuery.data.value?.supplyAddress?.addressLine1,
  )
</script>

<template>
  <Dialog>
    <slot />
    <DialogContent class="grid-rows-none overflow-y-auto">
      <DialogHeader>
        <DialogTitle class="pr-10">Need to cancel your move?</DialogTitle>
      </DialogHeader>

      <div class="space-y-4">
        <p>
          You can't cancel your move online, but our team can sort it for you.
        </p>
        <p>
          Get in touch and we'll keep your account open<template
            v-if="addressLine1"
          >
            at {{ addressLine1 }}</template
          >.
        </p>
        <p>
          Email us at
          <Link class="link" :to="`mailto:${HELP_EMAIL}`">{{
            HELP_EMAIL
          }}</Link>
          with "Cancel my move" in the subject line. You can also
          <button type="button" class="link" @click="openWebchat">
            chat online
          </button>
          with our team (Monday to Friday, 9am to 5pm).
        </p>
      </div>

      <DialogFooter>
        <DialogClose as-child>
          <Button variant="outline">Keep my move</Button>
        </DialogClose>
        <Button as-child>
          <Link :to="`mailto:${HELP_EMAIL}?subject=Cancel%20my%20move`">
            <Icon name="Email" class="mr-2 h-5 w-5" />
            Send an email
          </Link>
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
